import { productApi } from "@/services/api/products.api";
import appSnackbarService from "@/services/appSnackbar.service";

interface ProductRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface ProductPost {
  data: object;
  index: number;
}

interface ProductDelete {
  id: number;
  index: number;
}

export const productsState: any = {
  namespaced: false,
  state: {
    products: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false
  },
  mutations: {
    // load surveyMaterials
    ITEMS_FETCH_SUCCESS(state: any, payload: any) {
      state.products = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    ITEMS_FETCH_START(state: any) {
      state.fetching = true;
    },
    ITEMS_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    ITEM_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.products.splice(payload.index, 1, payload.data);
        // és betölti a data elemet
        // state.supplyAreas[payload.index] = payload.data;
      } else {
        // add
        state.products.push(payload.data);
      }
    },
    ITEM_SAVE_START(state: any) {
      state.fetching = true;
    },
    ITEM_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    ITEM_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.products.splice(payload.index, 1);
        state.loading = false;
      }
    },
    ITEM_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    ITEM_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
  },
  actions: {
    getProducts({ commit }: any, request: ProductRequest) {
      commit("ITEMS_FETCH_START");
      productApi
        .getAll(request)
        .then(response => {
          commit("ITEMS_FETCH_SUCCESS", response.data);
        })
        .catch(error => {
          commit("ITEMS_FETCH_ERROR", error);
        });
    },
    saveProduct({ commit }: any, payload: ProductPost) {
      commit("ITEM_SAVE_START");
      const editedIndex = payload.index;
      const promise = new Promise((resolve, reject) => {

        productApi
          .save(payload.data)
          .then(response => {
            commit("ITEM_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success("Success saving Box!");
            resolve(response);
          })
          .catch(error => {
            commit("ITEM_SAVE_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    deleteProduct({ commit }: any, payload: ProductDelete) {
      commit("ITEM_DELETE_START");

      const deletedIndex = payload.index;
      productApi
        .delete(payload.id)
        .then(response => {
          commit("ITEM_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning("Success deleting Box!");
        })
        .catch(error => {
          commit("ITEM_DELETE_ERROR", error);
          // appSnackbarService.error(error);
        });
    },
  }
};
